<template>
  <div class="admin-container">
    <div class="admin-header">
      <h1 class="admin-title">
        <v-icon class="title-icon">{{ pageIcon }}</v-icon>
        {{ pageName }}
      </h1>
    </div>
    <div class="admin-content">
      <PageTabs :tabs="tabs" :startTab="tabFromQuery" :showArrows="$vuetify.breakpoint.xs" />
    </div>
  </div>
</template>

<script>
import PageTabs from '../../components/PageTabs';
import ManagePatient from './ManagePatient';
import ManageAdmin from './ManageAdmin';
import Settings from './Settings';
import AppointmentTypes from './AppointmentTypes';
import CompanyInformation from './CompanyInformation';
import FormManagement from './FormManagement';
import DataService from '../../../_services/DataService';

export default {
  name: 'AdminUserManagement',
  props: ['template_props'],

  components: {
    PageTabs,
    ManageAdmin,
    ManagePatient,
    Settings,
  },
  data() {
    return {
      pageName: 'Admin',
      pageIcon: 'mdi-shield-account',
      tabFromQuery: null,
      tabs: [
        {label: 'Patient Management', section: ManagePatient},
        {label: 'Appointment Types', section: AppointmentTypes},
      ],
      admins: [],
      form: {},
    };
  },
  methods: {
    addView(label, component) {
      this.tabs.push({
        label: label,
        section: component,
      });
    },
    setAdminTabs() {
      this.addView('Client User Management', ManageAdmin);
      this.addView('Company Information', CompanyInformation);
      this.addView('Form Management', FormManagement);
      this.addView('Settings', Settings);
    },
    setPageData() {
      this.setPageName();
      if (DataService.getRole() === 'clientAdmin') {
        this.setAdminTabs();
      }
    },
    setPageName() {
      this.pageName = 'Admin';
    },
  },
  mounted() {
    this.setPageData();

    if (this.$route.query.tab) {
      const lowerRoute = this.$route.query.tab.toLowerCase();
      const tabIndex = this.tabs.findIndex((tab) => tab.label.toLowerCase() === lowerRoute);
      if (tabIndex !== -1) {
        this.tabFromQuery = tabIndex;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/mixins/_mobile-nav-spacing.scss';

$admin-title-color: #2d3748;
$admin-title-icon-color: #6b7280;
$admin-content-bg-color: #ffffff;
$admin-content-border-color: #e2e8f0;

.admin-container {
  padding: 16px !important;
  background-color: transparent !important;
  
  @media (max-width: $breakpoint-mobile) {
    padding: 12px !important;
  }

  @include mobile-nav-spacing;

  .admin-header {
    display: none;

    .admin-title {
      display: flex !important;
      align-items: center !important;
      font-size: 24px !important;
      font-weight: 600 !important;
      color: $admin-title-color !important;
      margin: 0 !important;
      font-family: 'Inter', sans-serif !important;
  
      .title-icon {
        font-size: 28px !important;
        color: $admin-title-icon-color !important;
        margin-right: 12px !important;
      }
  
      @media (max-width: $breakpoint-mobile) {
        font-size: 20px !important;
    
        .title-icon {
          font-size: 24px !important;
        }
      }
    }
  }

  .admin-content {
    background-color: $admin-content-bg-color !important;
    border-radius: 12px !important;
    box-shadow: $shadow-md !important;
    border: 1px solid $admin-content-border-color !important;
    overflow: hidden !important;
    padding: 0 !important;
  }
}
</style>
